import { z } from 'zod';

const SHIFT_PERIODS = ['صباحية', 'مسائية', 'ليلية'] as const;
const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/;

const staffRowSchema = z.object({
  role_title:  z.string().min(2, 'المسمى الوظيفي مطلوب'),
  staff_name:  z.string().min(2, 'اسم الموظف مطلوب'),
  sort_order:  z.number().int().optional(),
});

export const createDutyShiftSchema = z.object({
  shift_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'تاريخ غير صحيح'),
  period:     z.enum(SHIFT_PERIODS),
  start_time: z.string().regex(timeRegex, 'وقت البداية غير صحيح'),
  end_time:   z.string().regex(timeRegex, 'وقت النهاية غير صحيح'),
  staff:      z.array(staffRowSchema).min(1, 'يجب إضافة موظف مناوب واحد على الأقل'),
});

export const saveShiftReportSchema = z.object({
  shift_id: z.string().uuid(),
  content:  z.string().min(10, 'محتوى التقرير مطلوب'),
  summary:  z.string().optional(),
});

export type CreateDutyShiftInput = z.infer<typeof createDutyShiftSchema>;
export type SaveShiftReportInput = z.infer<typeof saveShiftReportSchema>;
